import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, useTheme } from '@mui/material';
import { DeleteVenueModal } from './DeleteVenueModal';
import { ArchiveVenueModal } from './ArchiveVenueModal';
import { DisconnectStripeModal } from './DisconnectStripeModal';

export const DangerPanel = ({ venue }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDisconnectModal, setOpenDisconnectModal] = useState(false);
  const [openArchiveModal, setOpenArchiveModal] = useState(false);

  const afterConfirm = () => {
    navigate(`/admin/organizations/${venue.organization.id}`);
  };

  return (
    <div style={{ width: '100%', padding: theme.spacing(2) }}>
      <Grid container spacing={2}>
        {venue.stripeAccount && (
          <>
            <Grid item xs={6}>
              <Button
                color="error"
                variant="contained"
                disabled={!venue.stripeAccount}
                fullWidth
                onClick={() => setOpenDisconnectModal(true)}
              >
                Disconnect Stripe Account
              </Button>
            </Grid>
            <Grid item xs={6} />
          </>
        )}
        <Grid item xs={6}>
          <Button
            color="primary"
            variant="outlined"
            fullWidth
            onClick={() => setOpenArchiveModal(true)}
          >
            {venue.discardedAt ? 'Restore Archived Venue' : 'Archive Venue'}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            color="error"
            variant="contained"
            fullWidth
            onClick={() => setOpenDeleteModal(true)}
          >
            Delete Venue
          </Button>
        </Grid>
      </Grid>
      <ArchiveVenueModal
        open={openArchiveModal}
        onClose={() => setOpenArchiveModal(false)}
        venue={venue}
        afterConfirm={afterConfirm}
      />
      <DeleteVenueModal
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        venue={venue}
        afterConfirm={afterConfirm}
      />
      <DisconnectStripeModal
        open={openDisconnectModal}
        onClose={() => setOpenDisconnectModal(false)}
        venue={venue}
      />
    </div>
  );
};
